// AI Generated Test
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { BaseEntityService } from '@client/app/blocks/base/base.entity.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { LabelService } from '@client/ng2/services/label-service/label.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-table',
    standalone: false,
    templateUrl: './pages-table.component.html',
})
export class PagesTableComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    @Input() override page: number = 1;
    @Input() override pageSize: number = 10;
    @Input() pages: any;
    @Input() progress: any;
    @Input() showNotifications: any;
    @Input() tab?: string | undefined;
    @Input() override isFiltersOpen: boolean = false;
    @Input() override currentSort: any;
    @Input() target?: string | undefined;
    @Input() subTarget?: string | undefined;
    @Input() ref?: string | undefined;

    // eslint-disable-next-line
    @Output('onPageChange') pageChange = new EventEmitter<any>();
    @Output() onPerPageChange = new EventEmitter<any>();
    @Output() onPageSort = new EventEmitter<any>();
    @Output() onFiltersChanges = new EventEmitter<any>();
    @Output() callBack = new EventEmitter<any>();
    @Output() isFiltersOpenChange = new EventEmitter<boolean>();

    eventId?: number;
    viewsColumIsAvailable?: boolean;
    pageDetailsIsAvailable?: boolean;
    hideNotifications: any[] = [];
    hasAccessToStats?: boolean;
    issueType: any = null;

    constructor (
        private translateService: TranslateService,
        private monEventService: MonEventService,
        private baseEntityService: BaseEntityService,
        private activeFeatureService: ActiveFeatureService,
        private labelService: LabelService,
    ) {
        super({ pages: true, labels: true });
        this.availableFilters.contains = [];
        this.filters.contains = [];
    }

    ngOnInit (): void {
        this.init();
    }

    ngOnDestroy (): void {
        if (this.eventId !== undefined) {
            this.monEventService.remove(this.eventId);
        }
    }

    init (): void {
        this.eventId = this.monEventService.addListener(
            'page-updated' as any,
            this.baseEntityService.updateEntryInArray(this, 'pages', 'id'),
        );

        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.currentSort = this.currentSort || {
            by: '',
            direction: '',
        };
        this.hideNotifications = this.hideNotifications || [];
        this.tab = this.tab || '';
        this.isFiltersOpen = this.isFiltersOpen || false;
        this.filters.contains = [];
        this.hasAccessToStats = this.activeFeatureService.isFeatureActive('statistics');
        this.availableFilters.contains = [];

        if (this.activeFeatureService.isFeatureActive('accessibility')) {
            this.availableFilters.contains.push({
                id: 'accessibility_checks_with_errors',
                notificationValue: 'accessibility',
                name: this.translateService.getString('Accessibility Issues'),
            });
        }
        if (this.activeFeatureService.isFeatureActivePure('seo_all')) {
            this.availableFilters.contains.push({
                id: 'seo_issues',
                notificationValue: 'seo',
                name: this.translateService.getString('SEO Issues'),
            });
        }
        if (this.activeFeatureService.isFeatureActivePure('qa_spellcheck')) {
            this.availableFilters.contains.push({
                id: 'confirmed_spelling_errors',
                notificationValue: 'misspellings',
                name: this.translateService.getString('Misspellings'),
            });
        }
        if (this.activeFeatureService.isFeatureActivePure('qa_links')) {
            this.availableFilters.contains.push({
                id: 'broken_links',
                notificationValue: 'dead-links',
                name: this.translateService.getString('Broken Links'),
            });
        }
        if (this.activeFeatureService.isFeatureActivePure('policies_all')) {
            this.availableFilters.contains.push({
                id: 'policy_errors',
                notificationValue: 'policies',
                name: this.translateService.getString('Policy errors'),
            });
        }
        if (this.activeFeatureService.isFeatureActivePure('admin_data_privacy')) {
            this.availableFilters.contains.push({
                id: 'data_protection_violations',
                notificationValue: 'data_protection_violations',
                name: this.translateService.getString('Data Privacy violations'),
            });
        }

        if (Array.isArray(this.showNotifications)) {
            this.availableFilters.contains = this.availableFilters.contains.filter((contain) => {
                return this.showNotifications.indexOf(contain.notificationValue) > -1;
            });
        }

        this.issueType = null;
        if (this.target === 'page-details-section-seo') {
            this.issueType = 'seo';
        } else if (this.target === 'page-details-section-qa') {
            switch (this.subTarget) {
                case 'brokenimages':
                    this.issueType = 'bimg';
                    break;
                case 'brokenlinks':
                    this.issueType = 'blnk';
                    break;
                case 'misspellings':
                    this.issueType = 'mspel';
                    break;
                case 'potential':
                    this.issueType = 'mspel';
                    break;
            }
        }
    }

    perPageChange (size: any): void {
        this.onPerPageChange.emit(size);
    }

    pageTitle (title: string): string {
        return title || '(' + this.translateService.getString('No title found') + ')';
    }

    createOrUpdateLabel (label: any): void {
        this.labelService.createOrUpdateLabel(label);
    }
}
